import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=610a8fc0&scoped=true&"
import script from "./CaseList.vue?vue&type=script&lang=js&"
export * from "./CaseList.vue?vue&type=script&lang=js&"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=610a8fc0&scoped=true&lang=css&"
import style1 from "./CaseList.vue?vue&type=style&index=1&id=610a8fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a8fc0",
  null
  
)

export default component.exports